import styles from '../ProductQuiz.module.scss';
import React from 'react';
import { Button, Flex, Text } from '@mantine/core';
import { Species, useProductQuiz } from '../ProductQuizContext';
import { QuestionTitle } from './QuestionTitle';
import { quizQuestionPage } from '../../../lib/analytics/events';
import { useTranslation } from 'react-i18next';

export const QuestionSpecies: React.FC = () => {
  const { t } = useTranslation();
  const { quizAnswers, setQuizAnswers, nextQuestion } = useProductQuiz();

  const selectedCat = quizAnswers.species === Species.Cat || undefined;
  const selectedDog = quizAnswers.species === Species.Dog || undefined;

  return (
    <>
      <QuestionTitle size={48}>
        {t('first_off')}
        <br />
        {t('tell_us_about_your')}
      </QuestionTitle>
      <Flex
        direction="row"
        align="center"
        justify="center"
        gap={16}
        sx={{ display: 'flex', flex: '1 0 0', width: '100%' }}
      >
        <Button
          unstyled
          data-active={selectedDog}
          className={styles.quizButton}
          py={30}
          px={16}
          onClick={() => {
            quizQuestionPage.quizPetTypeSelected('dog');
            setQuizAnswers({ ...quizAnswers, species: Species.Dog });
            nextQuestion();
          }}
          sx={{ flex: 1, borderRadius: 16 }}
        >
          <Text
            size={24}
            weight={600}
            lh="120%"
            sx={(theme) => ({ letterSpacing: '-0.48px', color: selectedDog ? theme.colors['fi-yellow'] : 'white' })}
          >
            {t('dog')}
          </Text>
        </Button>
        <Button
          unstyled
          data-active={selectedCat}
          className={styles.quizButton}
          py={30}
          px={16}
          onClick={() => {
            quizQuestionPage.quizPetTypeSelected('cat');
            setQuizAnswers({ ...quizAnswers, species: Species.Cat });
            nextQuestion();
          }}
          sx={{ flex: 1, borderRadius: 16 }}
        >
          <Text
            size={24}
            weight={600}
            lh="120%"
            sx={(theme) => ({ letterSpacing: '-0.48px', color: selectedCat ? theme.colors['fi-yellow'] : 'white' })}
          >
            {t('cat')}
          </Text>
        </Button>
      </Flex>
    </>
  );
};
